import { ClientPool } from "./types";

export const ClientPoolActions = {
    SetHaveUpdates: (haveUpdates) => ({
        type: ClientPool.HAVE_UPDATES,
        haveUpdates,
    }),
};
